import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { injectIntl } from '../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import {
  Form,
  PrimaryButton,
  FieldTextInput
} from '../../components';

import css from './TwoFactorForm.module.css';

const required = (intl, id, defaultMessage) => value => (value ? undefined : intl.formatMessage({ id, defaultMessage }));
const sixDigits = (intl, id, defaultMessage) => value => (/^\d{6}$/.test(value || '') ? undefined : intl.formatMessage({ id, defaultMessage }));

const TwoFactorFormComponent = props => (
  <FinalForm
    {...props}
    render={formRenderProps => {
      const {
        rootClassName,
        className,
        handleSubmit,
        inProgress,
        invalid,
        email,
        verifyCodeError,
        onResend,
        resendCooldown,
        resendInProgress,
        resendSent,
      } = formRenderProps;

      const classes = classNames(rootClassName || css.root, className);
      const submitInProgress = inProgress;
      const submitDisabled = invalid || submitInProgress;
      return (
        <Form className={classes} onSubmit={handleSubmit}>
          <div>
             <small>Enter the 6 digit code we sent to your email address {email?.replace(/(.{2}).+(@.+)/, '$1***$2')}</small>
              <FieldTextInput
                className={css.features}
                type="text"
                id={'code'}
                name={'code'}
                placeholder={'Please enter the verification code'}
                inputMode="numeric"
                autoComplete="one-time-code"
                maxLength={6}
                validate={value =>
                  required(props.intl, 'TwoFactorForm.codeRequired', 'Code is required')(value) ||
                  sixDigits(props.intl, 'TwoFactorForm.codeSixDigits', 'Enter 6 digits')(value)
                }
              />
          </div>
          {verifyCodeError ? (
            <div className={css.error}>
              {verifyCodeError}
            </div>
          ) : null}
          <PrimaryButton type="submit" inProgress={submitInProgress} disabled={submitDisabled}>
            Submit Code
          </PrimaryButton>
          <div className={css.resendRow}>
            <button
              type="button"
              className={css.resendButton}
              onClick={onResend}
              disabled={resendCooldown > 0 || resendInProgress}
            >
              {resendInProgress
                ? 'Sending…'
                : resendCooldown > 0
                ? `Resend code (${resendCooldown}s)`
                : 'Resend code'}
            </button>
            {resendSent ? (
              <span className={css.resendSent}>New code sent</span>
            ) : null}
          </div>
        </Form>
      );
    }}
  />
);

TwoFactorFormComponent.defaultProps = {
  inProgress: false,
  verifyCodeError: null,
  needPassword: false,
  email: null,
  onResend: null,
  resendCooldown: 0,
  resendInProgress: false,
  resendSent: false,

};

const { bool, string, func, number } = PropTypes;

TwoFactorFormComponent.propTypes = {
  onSubmit: func.isRequired,
  inProgress: bool,
  onResend: func,
  resendCooldown: number,
  resendInProgress: bool,
  resendSent: bool,
  needPassword: bool,
  email: string,
  className: string,
  rootClassName: string
};

const TwoFactorForm = compose(injectIntl)(TwoFactorFormComponent);
TwoFactorForm.displayName = 'TwoFactorForm';

export default TwoFactorForm;